import { Resources } from "../../Resources";

function MyResources() {
    return (
        <>
            <Resources />
        </>
    );
}

export default MyResources;